import { DrupalNodeBasicPage, DrupalNodeRelease, DrupalTaxonomyTermProduct, DrupalTaxonomyTerm, DrupalNodeExternalResource } from "@/types"
import { AddOnsMenu } from "./AddOnsMenu"
import { ResponsiveMenu } from "./ResponsiveMenu.client"
import { SidebarVersionedMenu, SidebarVersionedMenuLoading } from "../app/drupal/SidebarVersionedMenu"
import { VersionSelector } from "../app/drupal/VersionSelector.client"
import { DrupalMenuLinkContent } from "next-drupal"
import { getChildrenTerms } from "@/lib/drupal/drupal.server"
import { getSidebarMenu } from "@/lib/drupal/get-menus.server"
import { getActiveTrail } from "@/lib/drupal/util"


export const DocumentSidebar =  async({resource, product, version, path}: {
  resource: DrupalNodeBasicPage | DrupalNodeRelease | DrupalNodeExternalResource,
  product: DrupalTaxonomyTermProduct,
  version?: string
  path: string
}) => {
  const addOns = (product.parent?.length && product.parent[0].id == "virtual") ? getChildrenTerms<DrupalTaxonomyTermProduct>(product) : Promise.resolve<DrupalTaxonomyTermProduct[]>([])
  const relatedProducts = Promise.resolve(product.parent?.filter(term => term.id != "virtual"))
  const available = resource.field_product_version as DrupalTaxonomyTerm[] | undefined

  let menu = await getSidebarMenu(product.field_menu.resourceIdObjMeta.drupal_internal__target_id, version)

  if (product.field_flag_product_navigation) {
    const trail = getActiveTrail(menu, path)
    if (!trail || !trail[0].items) {
      return <></>
    }
    menu = trail ? trail[0].items as DrupalMenuLinkContent[] : menu
  }

  return <ResponsiveMenu 
            className="print:hidden group-data-[draw=closed]/body:lg:border-e group-data-[draw=closed]/body:lg:border-gray-600 xl:border-e xl:border-gray-600" 
            expandedClass="group-data-[draw=closed]/body:lg:basis-1/4 xl:basis-1/4 group-data-[draw=closed]/body:lg:shrink-0 xl::shrink-0" 
            orientation="left"
            openLabel="Show Sidebar Navigation"
            closeLabel="Hide Sidebar Navigation"
          >
        <SidebarVersionedMenu product={product} version={version} path={path}>
        { available && (
          <VersionSelector available={[...available.map(t => t.name)]} />
        )}
        </SidebarVersionedMenu>
        {!product.field_flag_product_navigation && (
          <>
            <hr className="border-gray-600" />
            <AddOnsMenu terms={addOns} className="text-navy-600" title="Add Ons" />
            <AddOnsMenu terms={relatedProducts} className="text-navy-600" title="Related Products" />
          </>
        )}
      </ResponsiveMenu>
}

export const DocumentSidebarLoading = () => {
  return <>
    <nav className="bg-gradient-to-bl bg-gray-400 to-navy-400 animate-pulse h-screen rounded"><SidebarVersionedMenuLoading /></nav>
  </>
}